export enum RbSubAction {
    CONFRIM_PRENOTIFICATION = "CONFIRM_PRENOTIFICATION",
    DENY_PRENOTIFICATION = "DENY_PRENOTIFICATION",
    UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION",
    UNSUBSCRIBE = "UNSUBSCRIBE",
    RENEW = "RENEW"
}